import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    index: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    destroy: async (missionId, requirementId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements/" + requirementId;

        try {
            const response = await fetch(url, {
                method: "DELETE",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    new: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements/new";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    create: async ({ missionId, selectedRequirementType, selectedCategoryType, selectedComparison, selectedValue, requirementGroup, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements";

        const body = JSON.stringify({
            requirement: {
                mission_id: missionId,
                requirement_type: selectedRequirementType,
                category_type: selectedCategoryType,
                comparison: selectedComparison,
                value: selectedValue,
            },
            requirement_group: requirementGroup,
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    createOrUpdate: async ({ missionId, requirementCategory, requirementKey, requirementValue, requirementGroupId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements/create_or_update";

        const body = JSON.stringify({
            requirement: {
                mission_id: missionId,
                category: requirementCategory,
                requirement_key: requirementKey,
                value: requirementValue,
            },
            requirement_group: requirementGroupId,
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    bulkUpdate: async ({ missionId, requirementCategory, requirements, requirementGroupId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements/bulk_update";

        const body = JSON.stringify({
            mission_requirements: {
                requirements: requirements,
                requirement_group_id: requirementGroupId,
                category: requirementCategory,
            }
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    bulkWalletUpdate: async ({ missionId, requirementCategory, requirements, requirementGroupId, handleRedirect = null }) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements/bulk_wallet_update";

        const body = JSON.stringify({
            wallet_requirements: {
                requirements: requirements,
                requirement_group_id: requirementGroupId,
                category: requirementCategory,
            }
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    newUserType: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements/new_user_types";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    indexUserTypes: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements/index_user_types";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    destroyAllUserTypes: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements/destroy_all_user_types";

        try {
            const response = await fetch(url, {
                method: "DELETE",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

    updateUserType: async (missionId, userTypes, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements/update_user_type";

        const body = JSON.stringify({
            user_types: userTypes
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                headers: addCommonHeaders(),
                credentials: 'include',
                body: body,
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    }

}